import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useFormContext, useWatch, ControllerRenderProps } from 'react-hook-form';
import { Typography } from '@mui/material';
import { FieldFactory } from '../../../../../components/Form/FieldFactory';
import { RendererType } from '../../../../../data-models/field-definition';
import { IField } from '../../../../../data-models/field2.data-model';
import { createFormField } from '../../../../../view-models/form.view-model';

const KpiSelectWrapperCss = css`
  &&&&& .MuiOutlinedInput-root {
    padding-left: 0;
    margin-left: 0;
  }
  &&&&& .MuiAutocomplete-input {
    padding: 0;
    margin: 0;
  }
  & .MuiOutlinedInput-root {
    border: 1px solid transparent;
  }
  & fieldset.MuiOutlinedInput-notchedOutline {
    border-color: transparent !important;
  }
  & .MuiFormControl-root {
    margin: 0;
    padding: 0;
  }
  padding: 0;
  margin: 0;
`;
interface ITextualKpiSelectProps {
  options: IField<unknown>[];
  fieldPath: string;
}
export function TextualKpiSelector({ options, fieldPath }: ITextualKpiSelectProps) {
  const methods = useFormContext();
  const value = useWatch({ name: fieldPath });
  const optionMap = useMemo(() => new Map(options.map((opt) => [opt.entityField, opt])), [options]);

  const formField = createFormField({
    key: `${fieldPath}.entityField`,
    renderer: RendererType.singleSelect,
    rendererMeta: {
      values: options.map((opt) => ({
        value: opt.entityField,
        displayName: opt.displayName,
      })),
    },
    disableClearable: true,
    placeholder: 'Select a textual KPI',
  });

  const formProps = {
    value: value ? optionMap.get(value.entityField)?.entityField : '',
    onChange: (val: string) => methods.setValue(fieldPath, optionMap.get(val), { shouldDirty: true }),
  } as ControllerRenderProps;

  const desc = value.description;

  return (
    <div css={KpiSelectWrapperCss} style={desc ? { marginTop: '-0.5rem' } : {}}>
      <FieldFactory formField={formField} formProps={formProps} />
      {Boolean(desc) && (
        <Typography variant='body2' color='text.secondary' mt={'-0.3rem'}>
          {desc}
        </Typography>
      )}
    </div>
  );
}
